import { render } from "./DescriptionArea.vue?vue&type=template&id=29c1c686&scoped=true"
import script from "./DescriptionArea.vue?vue&type=script&lang=js"
export * from "./DescriptionArea.vue?vue&type=script&lang=js"

import "./DescriptionArea.vue?vue&type=style&index=0&id=29c1c686&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c1c686"]])

export default __exports__